import { Lang } from 'constants/Lang';

import styles from './styles.module.css';

export const BoardEmpty: React.FC = () => (
    <div className={styles.root}>{Lang.ja.emptyMessage}</div>
)
